import styled from 'styled-components';
import { media } from '../themes/theme';
export const StyledTagListContainer = styled.div `
  position: relative;
  overflow-x: hidden;
  justify-content: ${props => props.fitsInViewport && props.align === 'center' ? 'center' : 'flex-start'};
  margin: ${props => props.fitsInViewport && props.align === 'center' ? '0 auto' : '0'};
  padding: 0;
  display: flex;

  ${media.laptop `
    justify-content:  'flex-start';
    margin: 0;
  `}
`;
export const TagListInner = styled.div `
  display: flex;
  overflow-x: auto;
  width: fit-content;
  /* hide scrollbar */
  scrollbar-width: none; /* Firefox */

  /* chrome, safari, edge */
  &::-webkit-scrollbar {
    display: none;
  }

  > span:first-of-type {
    margin-left: ${props => props.fitsInViewport && props.align === 'center'
    ? '0'
    : props.spacingLeft};
  }

  > *:not(:last-child) {
    margin-right: 0.25rem;
  }

  ${media.laptop `
    flex-wrap: wrap;
    overflow-x: auto;
    > * {
      margin-bottom: 0.75rem;
    }
    > *:not(:last-child) { 
      margin-right: 0.5rem;
    };

    > span:first-of-type {
      margin-left: 0;
    }
  
  `}
`;
